<nb-card class="profile-dialog">
  <nb-card-header>
    <div class="header-row">
      <div>
        <h6>{{ learnerName || ('pages.admin.learners.profileTitle' | translate) }}</h6>
        <span class="email" *ngIf="learnerEmail">{{ learnerEmail }}</span>
      </div>
      <button nbButton ghost (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <app-page-loader *ngIf="isLoading"></app-page-loader>

    <div *ngIf="!isLoading && data" class="profile-layout">
      <section class="profile-overview profile-section">
        <div class="section-heading">
          <div>
            <span class="section-kicker">{{ 'pages.admin.learners.layerSummary' | translate }}</span>
            <h4>Zusammenfassung</h4>
          </div>
          <span class="profile-count">{{ data.observations.length }} Beobachtungen</span>
        </div>
        <div *ngIf="!data.consolidated_summary" class="profile-empty-state">
          {{ 'pages.admin.learners.noData' | translate }}
        </div>
        <p class="narrative" *ngIf="summaryText()">{{ summaryText() }}</p>
        <ng-container
          *ngIf="data.consolidated_summary && !summaryText()"
          [ngTemplateOutlet]="valueView"
          [ngTemplateOutletContext]="{ $implicit: data.consolidated_summary }"
        ></ng-container>
      </section>

      <details *ngIf="learningProgressEntries().length > 0" class="profile-accordion profile-section">
        <summary class="profile-accordion-summary">
          <div>
            <span class="profile-accordion-title">{{ 'pages.admin.learners.layerProgress' | translate }}</span>
            <span class="profile-accordion-subtitle">Progress-Daten ohne Moodle-Kursliste</span>
          </div>
          <nb-icon icon="chevron-down-outline" class="profile-accordion-chevron"></nb-icon>
        </summary>
        <div class="profile-accordion-body">
          <div class="profile-kv">
            <div *ngFor="let entry of learningProgressEntries()" class="profile-kv-row">
              <div class="profile-kv-key">{{ formatKey(entry.key) }}</div>
              <div class="profile-kv-value">
                <ng-container
                  [ngTemplateOutlet]="valueView"
                  [ngTemplateOutletContext]="{ $implicit: entry.value }"
                ></ng-container>
              </div>
            </div>
          </div>
        </div>
      </details>

      <section class="profile-section observations-panel">
        <div class="section-heading compact">
          <div>
            <span class="section-kicker">{{ data.observations.length }} Einträge</span>
            <h4>{{ 'pages.admin.learners.layerObservations' | translate }}</h4>
          </div>
        </div>
        <div class="profile-table-panel">
          <div class="profile-list-toolbar" *ngIf="data.observations.length > 0">
            <input
              nbInput
              fullWidth
              fieldSize="small"
              placeholder="Beobachtungen filtern ..."
              [(ngModel)]="observationFilter"
              (ngModelChange)="expandedObservation = null"
            />
          </div>
          <div *ngIf="data.observations.length === 0" class="profile-empty-state">
            {{ 'pages.admin.learners.noData' | translate }}
          </div>
          <div *ngIf="data.observations.length > 0 && filteredObservations().length === 0" class="profile-empty-state">
            Keine Beobachtungen für diesen Filter.
          </div>
          <div class="observation-table-wrap" *ngIf="filteredObservations().length > 0">
              <table class="detail-table observation-table">
                <thead>
                  <tr>
                    <th>Typ</th>
                    <th>Thema</th>
                    <th>Konfidenz</th>
                    <th>Quelle</th>
                    <th>Datum</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let row of observationRows()">
                    <tr class="observation-row" (click)="toggleObservation(row.index)">
                      <td>
                        <span class="observation-chip" *ngIf="row.observation?.type; else emptyCell">
                          {{ formatKey(row.observation.type) }}
                        </span>
                      </td>
                      <td class="observation-topic">{{ observationTitle(row.observation, row.index) }}</td>
                      <td>{{ row.observation?.confidence != null ? row.observation.confidence : '—' }}</td>
                      <td>{{ row.observation?.source_session || row.observation?.source || '—' }}</td>
                      <td>
                        <ng-container *ngIf="observationDate(row.observation) as dateValue; else emptyCell">
                          {{ dateValue | date: 'dd.MM.yy HH:mm' }}
                        </ng-container>
                      </td>
                      <td class="observation-expand">
                        <nb-icon
                          [icon]="expandedObservation === row.index ? 'chevron-up-outline' : 'chevron-down-outline'"
                        ></nb-icon>
                      </td>
                    </tr>
                    <tr *ngIf="expandedObservation === row.index" class="observation-detail-row">
                      <td colspan="6">
                        <div class="observation-body">
                          <p>{{ row.observation?.content || '—' }}</p>
                          <div class="profile-kv observation-detail-meta" *ngIf="observationMetaEntries(row.observation).length > 0">
                            <div *ngFor="let entry of observationMetaEntries(row.observation)" class="profile-kv-row">
                              <div class="profile-kv-key">{{ formatKey(entry.key) }}</div>
                              <div class="profile-kv-value">
                                <ng-container
                                  [ngTemplateOutlet]="valueView"
                                  [ngTemplateOutletContext]="{ $implicit: entry.value }"
                                ></ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </section>

      <details *ngIf="getMoodleCourses().length > 0" class="profile-accordion profile-section moodle-section" open>
        <summary class="profile-accordion-summary">
          <div>
            <span class="profile-accordion-title">Moodle</span>
            <span class="profile-accordion-subtitle">
              {{ getMoodleCourses().length }} Moodle-Kurse, Status und Noten
            </span>
          </div>
          <nb-icon icon="chevron-down-outline" class="profile-accordion-chevron"></nb-icon>
        </summary>
        <div class="profile-accordion-body table-scroll">
          <div class="profile-list-toolbar">
            <input
              nbInput
              fullWidth
              fieldSize="small"
              placeholder="Moodle-Kurse filtern ..."
              [(ngModel)]="moodleCourseFilter"
            />
          </div>
                <table class="detail-table moodle-courses-table">
                  <thead>
                    <tr>
                      <th>Kurs</th>
                      <th>Kurzname</th>
                      <th>Kategorie</th>
                      <th>Status</th>
                      <th>{{ "pages.dozent.participants.profile.progress" | translate }}</th>
                      <th>Note</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let course of filteredMoodleCourses()">
                      <td>
                        <span class="moodle-course-name">{{ getMoodleCourseName(course) }}</span>
                      </td>
                      <td>{{ getMoodleCourseShortname(course) }}</td>
                      <td>{{ getMoodleCourseCategory(course) }}</td>
                      <td><span class="observation-chip">{{ getMoodleCourseStatus(course) }}</span></td>
                      <td>{{ getMoodleCourseProgress(course) }}</td>
                      <td>{{ getMoodleCourseGrade(course) }}</td>
                    </tr>
                  </tbody>
                </table>
          <div *ngIf="filteredMoodleCourses().length === 0" class="profile-empty-state">
            Keine Moodle-Kurse für diesen Filter.
          </div>
        </div>
      </details>
    </div>
  </nb-card-body>
</nb-card>

<ng-template #emptyCell>—</ng-template>

<ng-template #valueView let-value>
  <span *ngIf="isPrimitive(value)" class="profile-primitive">
    {{ formatPrimitive(value) }}
  </span>

  <div *ngIf="isArray(value)" class="profile-array">
    <div *ngIf="value.length === 0" class="profile-empty-inline">—</div>
    <div *ngFor="let item of value; let i = index" class="profile-array-item">
      <span class="profile-index">{{ i + 1 }}</span>
      <ng-container
        [ngTemplateOutlet]="valueView"
        [ngTemplateOutletContext]="{ $implicit: item }"
      ></ng-container>
    </div>
  </div>

  <div *ngIf="isObject(value)" class="profile-kv">
    <div *ngIf="entries(value).length === 0" class="profile-empty-inline">—</div>
    <div *ngFor="let entry of entries(value)" class="profile-kv-row">
      <div class="profile-kv-key">{{ formatKey(entry.key) }}</div>
      <div class="profile-kv-value">
        <ng-container
          [ngTemplateOutlet]="valueView"
          [ngTemplateOutletContext]="{ $implicit: entry.value }"
        ></ng-container>
      </div>
    </div>
  </div>
</ng-template>
